"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRolesWithAnyPermissions = exports.hasAnyRequiredPermission = exports.hasAllRequiredPermissions = void 0;
const types_1 = require("./types");
function hasAllRequiredPermissions(requiredPermissions, userPermissions) {
    return requiredPermissions.every((requiredPermission) => userPermissions.includes(requiredPermission));
}
exports.hasAllRequiredPermissions = hasAllRequiredPermissions;
function hasAnyRequiredPermission(requiredPermissions, userPermissions) {
    if (requiredPermissions.length === 0) {
        return true;
    }
    return requiredPermissions.some((requiredPermission) => userPermissions.includes(requiredPermission));
}
exports.hasAnyRequiredPermission = hasAnyRequiredPermission;
function getRolesWithAnyPermissions(permissions) {
    const roles = new Set();
    const rolesWithPermissions = (0, types_1.getDefinedRolesWithPermissions)();
    permissions.forEach((permission) => {
        for (const role in rolesWithPermissions) {
            if (rolesWithPermissions[role].includes(permission)) {
                roles.add(role);
            }
        }
    });
    return Array.from(roles);
}
exports.getRolesWithAnyPermissions = getRolesWithAnyPermissions;
